import { render, staticRenderFns } from "./billingInvoice.vue?vue&type=template&id=1b870a62&scoped=true"
import script from "./billingInvoice.vue?vue&type=script&lang=js"
export * from "./billingInvoice.vue?vue&type=script&lang=js"
import style0 from "./billingInvoice.vue?vue&type=style&index=0&id=1b870a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b870a62",
  null
  
)

export default component.exports